

$('.main__map__balkon2 .map__main__row--5 .map__main__col--left--1 .seat-ctn').curve({"x1":33,"y1":200,"x2":66,"y2":200,x3: 95, y3: 0})







$('.main__map__balkon2 .map__main__row--5 .map__main__col--right--1 .seat-ctn').curve({"x1":33,"y1":200,"x2":66,"y2":200,x3: 95, y3: 0})










$('.main__map__balkon2 .map__main__row--5 .map__main__col--left--1 .seat-ctn .state').each(function(index){
    $(this).css('transform', 'rotate('+ (-index*1) +  'deg)')
})










$($('.main__map__balkon2 .map__main__row--5 .map__main__col--right--1 .seat-ctn .state').get().reverse()).each(function(index){
    $(this).css('transform', 'rotate('+ (index*1) +  'deg)')
})


